import { VFC } from 'react'
import { ToastData } from 'src/hooks/useToast'
import styled from 'styled-components'
import { Toast } from './Toast'

export type ToastContainerProps = {
  toasts: ToastData[]
  onRemoveToast: (id: string) => void
}

const ToastContainerComponent: VFC<ToastContainerProps> = ({
  toasts,
  onRemoveToast,
}) => {
  return (
    <ToastContainerWrapper>
      {toasts.map((toast, index) => (
        <ToastItemWrapper
          key={toast.id}
          style={{ top: `${84 + index * 80}px` }}
        >
          <Toast
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={() => onRemoveToast(toast.id)}
            isVisible={true}
          />
        </ToastItemWrapper>
      ))}
    </ToastContainerWrapper>
  )
}

const ToastContainerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  pointer-events: none;
`

const ToastItemWrapper = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  pointer-events: auto;
`

export const ToastContainer = ToastContainerComponent
